var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#DD4B39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3225 19.0331C22.3869 19.3738 22.433 19.7145 22.433 20.1565C22.433 24.015 19.8453 26.75 15.95 26.75C12.2205 26.75 9.20001 23.7296 9.20001 20C9.20001 16.2704 12.2205 13.25 15.95 13.25C17.7734 13.25 19.2928 13.913 20.4715 15.0181L18.6389 16.7769C18.1417 16.2981 17.2669 15.7364 15.95 15.7364C13.6478 15.7364 11.7692 17.6426 11.7692 20C11.7692 22.3574 13.6478 24.2636 15.95 24.2636C18.6205 24.2636 19.6243 22.339 19.7808 21.3537H15.95V19.033H22.3225V19.0331ZM28.8406 19.2594V17.3H26.8719V19.2594H24.9125V21.2281H26.8719V23.1875H28.8406V21.2281H30.8V19.2594H28.8406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmailIcon.b0cfdf04359f5bfcfa4524d5d071e8e8.svg";
export { ForwardRef as ReactComponent };